import { baseApi } from '@Services/api';
import { RequestTypes } from '@Constants/api';

const referralApis = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getReferrals: builder.query({
            query: (payload) => ({
                url: '/v0/user/referrals',
                method: RequestTypes.GET,
                params: payload
            })
        })
    })
});

export const { useLazyGetReferralsQuery } = referralApis;
